import { Injectable, signal } from '@angular/core';
import { Params } from '@angular/router';
import { URL_PARAMS } from '@global/constants';

@Injectable({ providedIn: 'root' })
export class QueryParamsStore {
  private readonly _params = signal<Partial<BackendParams>>({});
  readonly params = this._params.asReadonly();

  capture(qp: Params): void {
    const next: Partial<BackendParams> = {};

    if (qp[URL_PARAMS.verVM] != null) next.verVM = qp[URL_PARAMS.verVM];
    if (qp[URL_PARAMS.verVU] != null) next.verVU = qp[URL_PARAMS.verVU].toUpperCase();
    if (qp[URL_PARAMS.vorVM] != null) next.vorVM = qp[URL_PARAMS.vorVM];
    if (qp[URL_PARAMS.parVM] != null) next.parVM = qp[URL_PARAMS.parVM];
    if (qp[URL_PARAMS.antVM] != null) next.antVM = qp[URL_PARAMS.antVM];
    if (qp[URL_PARAMS.vehicle_kind] != null) next.vehicle_kind = qp[URL_PARAMS.vehicle_kind];
    if (qp[URL_PARAMS.test] != null) next.test = qp[URL_PARAMS.test];

    this._params.update(prev => ({ ...prev, ...next }));
  }
  snapshot(): Partial<BackendParams> {
    return this._params();
  }
}
export interface BackendParams {
  verVM?: string;
  verVU?: string;
  vorVM?: string;
  parVM?: string;
  antVM?: string;
  vehicle_kind?: string;
  test?: string;
}
